import React, { Fragment } from 'react';

import { Menu, MenuButtonProps, Transition } from '@headlessui/react';
import { ChevronDown } from 'lucide-react';

import { Icon } from './Icon';

function classNames(...classes: string[]): string {
  return classes.filter(Boolean).join(' ');
}

interface DropdownItem {
  label: string;
  icon?: string;
  onClick?: () => void;
}

interface DropdownProps extends MenuButtonProps<any> {
  items: DropdownItem[];
  label: string;
}

export const Dropdown = ({ items = [], label, ...props }: DropdownProps): JSX.Element => {
  const handleClick = (item: DropdownItem): void => {
    if (typeof item?.onClick === 'function') item.onClick();
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button {...props} className="btn btn-secondary flex items-center ml-auto">
          {label}
          <ChevronDown className="w-5 h-5 ml-3 -mr-1 text-gray-400" aria-hidden="true" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="ring-1 ring-gray-0.0 focus:outline-none absolute right-0 z-10 w-56 mt-2 origin-top-right bg-white-0.0 rounded-md shadow-lg">
          {items.map((item, index) => {
            let className = '';
            if (index === 0) className = 'rounded-t-md';
            else if (index === items.length - 1) className = 'rounded-b-md';
            return (
              <Menu.Item key={item.label}>
                {({ active }: { active: boolean }) => (
                  <a
                    href="#"
                    className={classNames(
                      active ? 'bg-gray-0.0' : '',
                      'group flex items-center px-4 py-2 text-sm ',
                      className
                    )}
                    onClick={() => handleClick(item)}
                  >
                    {!!item.icon && (
                      <Icon
                        size={14}
                        name={item.icon}
                        className="group-hover:text-gray-500 mr-3 text-gray-400"
                        aria-hidden="true"
                      />
                    )}
                    {item.label}
                  </a>
                )}
              </Menu.Item>
            );
          })}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
